import { render, staticRenderFns } from "./potion_effects.vue?vue&type=template&id=e40750de"
import script from "./potion_effects.vue?vue&type=script&lang=js"
export * from "./potion_effects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports